import * as React from "react";
import {Button, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {LcdIcon} from "../common/ui/icon/LcdIcon";
import {Product} from "../products/model";
import {AddToServiceForm, CloseAddToServiceFormButton, ExecuteButton} from "./AddToServiceForm";

interface ButtonProps {
  disabled?: boolean;
  inputProducts?: Product[];
}

interface ButtonState {
  showModal: boolean;
}

export class AddToServiceButton extends React.Component<ButtonProps, ButtonState> {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  closeCreationModal = () => this.setState({showModal: false});

  openCreationModal = () => this.setState({showModal: true});

  render() {
    const {disabled, inputProducts} = this.props;
    const {showModal} = this.state;
    const noData = !inputProducts || inputProducts.length === 0;

    const buttonIsDisabled = disabled || showModal || noData;

    let addToServiceButton = null;

    if (buttonIsDisabled) {
      const reason = <FormattedMessage id="studio.services.add-to-service-button.reason"
                                       defaultMessage="Select some products from the list below"/>;
      //adding an overlay (tooltip) to a disabled element requires some witchcraft, as disabled elements
      //do not respond to mouse events
      //see remark in bootstrap docs: http://getbootstrap.com/javascript/#tooltips
      //and https://github.com/react-bootstrap/react-bootstrap/issues/1588
      addToServiceButton = (
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{reason}</Tooltip>}>
            <div style={{cursor: "not-allowed"}}>
              <Button style={{pointerEvents : "none"}} onClick={this.openCreationModal} disabled>
                <LcdIcon icon="plus"/> <FormattedMessage
                  id="studio.services.add-to-service-button.disabled-label"
                  defaultMessage="Add to service"/>
              </Button>
            </div>
          </OverlayTrigger>
      );
    } else {
      addToServiceButton = (
          <Button onClick={this.openCreationModal}>
            <LcdIcon icon="plus"/> <FormattedMessage
              id="studio.services.add-to-service-button.label"
              defaultMessage="Add to Service"/>
          </Button>
      );
    }

    return (
        <div>
          {addToServiceButton}

          <Modal show={showModal} onHide={this.closeCreationModal} bsSize="large" backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title><FormattedMessage id="studio.services.add-to-service-button.title"
                                             defaultMessage="Add to Service"/></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AddToServiceForm inputProducts={inputProducts}/>
            </Modal.Body>
            <Modal.Footer>
              <ExecuteButton />
              <CloseAddToServiceFormButton onClick={this.closeCreationModal} />
            </Modal.Footer>
          </Modal>
        </div>
    );
  }
}
